<div class="space-y-6">
  
    <!-- Pages and Menu Grid -->
    <div *ngIf="selectedDomain && pages.length >= 0" class="grid gap-6">
        <!-- Pages List - 2 columns -->
        <div class=" bg-gray-800/50 rounded-lg border border-gray-700/50 backdrop-blur-sm">
            <div class="p-5">
                <div class="flex justify-between items-center mb-6">
                    <div>
                        <h3 class="text-lg font-semibold text-gray-100">Pagina's</h3>
                        <p class="text-sm text-gray-400 mt-1">Beheer je website content</p>
                    </div>
                    <button
                        (click)="showAddPageModal = true"
                        class="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                        <svg class="-ml-0.5 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                        </svg>
                        Nieuwe Pagina
                    </button>
                </div>

                <!-- Empty State -->
                <div *ngIf="pages.length === 0" class="text-center py-12">
                    <svg class="mx-auto h-16 w-16 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <h3 class="text-lg font-medium text-gray-200 mb-2">Nog geen pagina's gemaakt</h3>
                    <p class="text-sm text-gray-400 mb-6">Maak je eerste pagina om te beginnen</p>
                    <button
                        (click)="showAddPageModal = true"
                        class="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                        <svg class="-ml-0.5 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                        </svg>
                        Maak je eerste pagina
                    </button>
                </div>

                <!-- Pages List with Pagination -->
                <div *ngIf="pages.length > 0">
                    <!-- Items Per Page Selector -->
                    <div class="flex items-center justify-between mb-4">
                        <div class="flex items-center gap-2">
                            <span class="text-sm text-gray-400">Items per pagina:</span>
                            <select 
                                [(ngModel)]="itemsPerPage"
                                (change)="changeItemsPerPage(itemsPerPage)"
                                class="text-sm bg-gray-700 text-gray-200 border border-gray-600 rounded px-2 py-1 hover:bg-gray-600 focus:outline-none focus:ring-1 focus:ring-indigo-500">
                                <option [value]="20">20</option>
                                <option [value]="50">50</option>
                            </select>
                        </div>
                        <div class="text-sm text-gray-400">
                            {{ (currentPage - 1) * itemsPerPage + 1 }}-{{ Math.min(currentPage * itemsPerPage, sortedPages.length) }} van {{ sortedPages.length }}
                        </div>
                    </div>

                    <!-- Pages Grid -->
                    <div class="grid gap-4 max-h-[32rem] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-800 mb-4">
                        <div *ngFor="let page of paginatedPages"
                            class="group bg-gray-900/50 rounded-lg border border-gray-700/50 p-4 hover:border-gray-600 transition-colors">
                            <div class="flex items-center justify-between">
                                <div class="min-w-0 flex-1">
                                    <a [routerLink]="['/pages', page.id]" 
                                       class="text-sm font-medium text-gray-200 hover:text-indigo-400 truncate cursor-pointer transition-colors">
                                        {{ page.title }}
                                    </a>
                                </div>
                                <div class="ml-4 flex items-center space-x-2">
                                    <span class="text-xs text-gray-500">{{ page.updatedAt | date:'short' }}</span>
                                    <button 
                                        (click)="toggleHomepage(page)"
                                        [class]="page.isHomepage === true ? 
                                          'text-yellow-400 hover:text-yellow-300' : 
                                          'text-gray-500 hover:text-gray-400'"
                                        class="inline-flex items-center p-1.5 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                        [title]="page.isHomepage === true ? 'Homepage - klik om te verwijderen' : 'Instellen als homepage'">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                        </svg>
                                    </button>
                                    <button 
                                        (click)="togglePublished(page)"
                                        [class]="page.published !== false ? 
                                          'text-green-400 hover:text-green-300' : 
                                          'text-gray-500 hover:text-gray-400'"
                                        class="inline-flex items-center p-1.5 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                        [title]="page.published !== false ? 'Gepubliceerd - klik om te verbergen' : 'Niet gepubliceerd - klik om te publiceren'">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </button>
                                    <a [routerLink]="['/pages', page.id]" 
                                        class="inline-flex items-center p-1.5 text-gray-400 hover:text-indigo-400 rounded-lg 
                                        transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                        </svg>
                                    </a>
                                    <button (click)="openDuplicateModal(page)" 
                                        class="inline-flex items-center p-1.5 text-gray-400 hover:text-indigo-400 rounded-lg 
                                        transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                        title="Dupliceren">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                        </svg>
                                    </button>
                                    <button (click)="openDeleteModal(page)" 
                                        class="inline-flex items-center p-1.5 text-gray-400 hover:text-red-400 rounded-lg 
                                        transition-colors focus:outline-none focus:ring-2 focus:ring-red-500"
                                        title="Verwijderen">
                                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Pagination Controls -->
                    <div *ngIf="totalPages > 1" class="flex items-center justify-between border-t border-gray-700 pt-4">
                        <button
                            (click)="goToPage(currentPage - 1)"
                            [disabled]="currentPage === 1"
                            class="px-3 py-2 text-sm font-medium text-gray-300 bg-gray-700 rounded-md hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                            Vorige
                        </button>
                        <div class="flex items-center gap-2">
                            <button
                                *ngFor="let pageNum of getPageNumbers()"
                                (click)="goToPage(pageNum)"
                                [class]="pageNum === currentPage 
                                    ? 'bg-indigo-600 text-white' 
                                    : 'bg-gray-700 text-gray-300 hover:bg-gray-600'"
                                class="px-3 py-2 text-sm font-medium rounded-md transition-colors">
                                {{ pageNum }}
                            </button>
                        </div>
                        <button
                            (click)="goToPage(currentPage + 1)"
                            [disabled]="currentPage === totalPages"
                            class="px-3 py-2 text-sm font-medium text-gray-300 bg-gray-700 rounded-md hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                            Volgende
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Menu Structure - 1 column -->
        <!-- <div class="col-span-1">
            <app-menu-editor 
              *ngIf="selectedDomain"
              [domain]="selectedDomain"
              [currentLocale]="currentLocale"
              (menuChanged)="onMenuChanged()"
            ></app-menu-editor>
        </div> -->
    </div>
</div>

<!-- Add the modal at the end of the template -->
<div *ngIf="showAddPageModal" class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>

  <div class="fixed inset-0 z-50 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg bg-gray-800 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
        <div>
          <div class="mt-3 text-center sm:mt-5">
            <h3 class="text-lg font-semibold leading-6 text-gray-200" id="modal-title">
              Nieuwe Pagina Aanmaken
            </h3>
            <div class="mt-4">
              <input
                type="text"
                [(ngModel)]="newPageTitle"
                (keyup.enter)="addPage()"
                placeholder="Voer paginatitel in"
                class="block w-full rounded-md border-0 bg-gray-700 py-2 px-3 text-gray-200 shadow-sm ring-1 ring-inset ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
          <button
            type="button"
            (click)="addPage()"
            [disabled]="isSubmitting || !newPageTitle.trim()"
            class="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed sm:col-start-2">
            <svg *ngIf="isSubmitting" class="animate-spin -ml-1 mr-2 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Pagina Aanmaken
          </button>
          <button
            type="button"
            (click)="showAddPageModal = false"
            class="mt-3 inline-flex w-full justify-center rounded-md bg-gray-700 px-3 py-2 text-sm font-semibold text-gray-200 shadow-sm ring-1 ring-inset ring-gray-600 hover:bg-gray-600 sm:col-start-1 sm:mt-0">
            Annuleren
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Duplicate Page Modal -->
<div *ngIf="showDuplicateModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="duplicate-modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" (click)="showDuplicateModal = false"></div>

  <!-- Modal container -->
  <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
    <div class="relative w-full max-w-lg transform overflow-hidden rounded-xl bg-gray-800 shadow-2xl transition-all border border-gray-700/50" 
         (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="flex items-center justify-between border-b border-gray-700/50 px-4 py-3 sm:px-5 sm:py-3.5">
        <h3 class="text-lg font-semibold text-gray-100" id="duplicate-modal-title">
          Pagina Dupliceren
        </h3>
        <button
          (click)="showDuplicateModal = false"
          class="text-gray-400 hover:text-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded-lg p-1"
          aria-label="Sluiten">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Modal content -->
      <div class="px-4 py-4 sm:px-5 sm:py-5">
        <div class="space-y-4">
          <!-- Duplicate type selection -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-3">Dupliceer optie:</label>
            <div class="space-y-2">
              <label class="flex items-center p-3 bg-gray-900/50 rounded-lg border border-gray-700/50 hover:border-gray-600 cursor-pointer transition-colors">
                <input
                  type="radio"
                  name="duplicateType"
                  value="same-language"
                  [(ngModel)]="duplicateType"
                  class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-600">
                <span class="ml-3 text-sm text-gray-200">Binnen dezelfde taal</span>
              </label>
              <label class="flex items-center p-3 bg-gray-900/50 rounded-lg border border-gray-700/50 hover:border-gray-600 cursor-pointer transition-colors">
                <input
                  type="radio"
                  name="duplicateType"
                  value="other-language"
                  [(ngModel)]="duplicateType"
                  class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-600">
                <span class="ml-3 text-sm text-gray-200">Naar een andere taal</span>
              </label>
              <label class="flex items-center p-3 bg-gray-900/50 rounded-lg border border-gray-700/50 hover:border-gray-600 cursor-pointer transition-colors">
                <input
                  type="radio"
                  name="duplicateType"
                  value="other-domain"
                  [(ngModel)]="duplicateType"
                  class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-600">
                <div class="ml-3">
                  <span class="text-sm text-gray-200">Naar een ander domein</span>
                  <p class="text-xs text-gray-400 mt-0.5">Kopieer de pagina inclusief alle content naar een ander domein</p>
                </div>
              </label>
            </div>
          </div>

          <!-- Language selector (only for other-language) -->
          <div *ngIf="duplicateType === 'other-language'">
            <label for="duplicate-language" class="block text-sm font-medium text-gray-300 mb-2">Selecteer taal:</label>
            <select
              id="duplicate-language"
              [(ngModel)]="duplicateTargetLanguage"
              class="block w-full rounded-lg bg-gray-700 border-transparent px-4 py-2.5 pr-8 text-gray-200
                hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20
                transition-colors duration-200">
              <option value="">-- Selecteer taal --</option>
              <option *ngFor="let lang of availableLanguages" [value]="lang.code" [disabled]="lang.code === currentLocale">
                {{ lang.name }} {{ lang.code === currentLocale ? '(huidige taal)' : '' }}
              </option>
            </select>
          </div>

          <!-- Domain selector (only for other-domain) -->
          <div *ngIf="duplicateType === 'other-domain'">
            <label for="duplicate-domain" class="block text-sm font-medium text-gray-300 mb-2">Selecteer domein:</label>
            <select
              id="duplicate-domain"
              [(ngModel)]="duplicateTargetDomain"
              class="block w-full rounded-lg bg-gray-700 border-transparent px-4 py-2.5 pr-8 text-gray-200
                hover:bg-gray-600 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20
                transition-colors duration-200">
              <option value="">-- Selecteer domein --</option>
              <option *ngFor="let domain of domains" [value]="domain" [disabled]="domain === selectedDomain">
                {{ domain }} {{ domain === selectedDomain ? '(huidig domein)' : '' }}
              </option>
            </select>
          </div>

          <!-- New title input -->
          <div>
            <label for="duplicate-title" class="block text-sm font-medium text-gray-300 mb-2">Nieuwe titel:</label>
            <input
              id="duplicate-title"
              type="text"
              [(ngModel)]="duplicateNewTitle"
              placeholder="Voer nieuwe paginatitel in"
              class="block w-full rounded-md border-0 bg-gray-700 py-2 px-3 text-gray-200 shadow-sm ring-1 ring-inset ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
      </div>

      <!-- Modal footer -->
      <div class="border-t border-gray-700/50 px-4 py-3 sm:px-5 sm:py-4 sm:flex sm:flex-row-reverse sm:gap-3">
        <button
          type="button"
          (click)="duplicatePage()"
          [disabled]="isDuplicating || !duplicateNewTitle.trim() || (duplicateType === 'other-language' && !duplicateTargetLanguage) || (duplicateType === 'other-domain' && !duplicateTargetDomain)"
          class="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed sm:ml-3 sm:w-auto">
          <svg *ngIf="isDuplicating" class="animate-spin -ml-1 mr-2 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Dupliceren
        </button>
        <button
          type="button"
          (click)="showDuplicateModal = false"
          class="mt-3 inline-flex w-full justify-center rounded-md bg-gray-700 px-3 py-2 text-sm font-semibold text-gray-200 shadow-sm ring-1 ring-inset ring-gray-600 hover:bg-gray-600 sm:mt-0 sm:w-auto">
          Annuleren
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Page Modal -->
<div *ngIf="showDeleteModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="delete-modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-gray-900/75 backdrop-blur-sm transition-opacity" (click)="showDeleteModal = false"></div>

  <!-- Modal container -->
  <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
    <div class="relative w-full max-w-lg transform overflow-hidden rounded-xl bg-gray-800 shadow-2xl transition-all border border-gray-700/50" 
         (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="flex items-center justify-between border-b border-gray-700/50 px-4 py-3 sm:px-5 sm:py-3.5">
        <h3 class="text-lg font-semibold text-gray-100" id="delete-modal-title">
          Pagina Verwijderen
        </h3>
        <button
          (click)="showDeleteModal = false"
          class="text-gray-400 hover:text-gray-200 transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded-lg p-1"
          aria-label="Sluiten">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Modal content -->
      <div class="px-4 py-4 sm:px-5 sm:py-5">
        <div class="space-y-4">
          <div class="flex items-center justify-center">
            <div class="flex-shrink-0 w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/20 flex items-center justify-center">
              <svg class="w-6 h-6 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
          </div>
          <div class="text-center">
            <p class="text-sm text-gray-300">
              Weet je zeker dat je de pagina <strong class="text-white">"{{ pageToDelete?.title }}"</strong> wilt verwijderen?
            </p>
            <p class="mt-2 text-xs text-gray-400">
              Deze actie kan niet ongedaan worden gemaakt.
            </p>
          </div>
        </div>
      </div>

      <!-- Modal footer -->
      <div class="border-t border-gray-700/50 px-4 py-3 sm:px-5 sm:py-4 sm:flex sm:flex-row-reverse sm:gap-3">
        <button
          type="button"
          (click)="confirmDelete()"
          class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 sm:ml-3 sm:w-auto">
          Verwijderen
        </button>
        <button
          type="button"
          (click)="showDeleteModal = false"
          class="mt-3 inline-flex w-full justify-center rounded-md bg-gray-700 px-3 py-2 text-sm font-semibold text-gray-200 shadow-sm ring-1 ring-inset ring-gray-600 hover:bg-gray-600 sm:mt-0 sm:w-auto">
          Annuleren
        </button>
      </div>
    </div>
  </div>
</div>